/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import './ClaimViewModal.css';
import CustomModal from '../../CustomModal/CustomModal';
import ModalFooter from '../../CustomModal/ModalFooter';
import ModalHeader from '../../CustomModal/ModalHeader';
import CardContentTile from '../../../components/CardContentTile/CardContentTile';
import { fonts, themes } from '../../../themes/themes';
import DropAndSelect from '../../../components/DropAndSelect/DropAndSelect';
import VerticalBarController from '../../../components/VerticalBar/VerticalBarController';
import { getAmount } from '../../../configs/utils';
import { useAppSelector } from '../../../../infra/hooks';
import { baseDateFormatting } from '../../../helper';
import { DateField } from '../../../../components';

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  claimViewData: any;
  trans?: any;
}

const ClaimViewModalPresenter = ({
  isModalOpen,
  closeModal,
  claimViewData,
  trans,
}: ModalProps) => {
  const handleSubmit = () => {
    closeModal();
  };

  const currency = useAppSelector((state) => state.authSlice.currency);
  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="755px"
      modalWidth="auto"
    >
      <ModalHeader
        modal={{ modal_title: trans('Claim Details') }}
        closeModal={closeModal}
      />
      <Grid
        container
        spacing={1}
        style={{
          marginTop: '15px',
        }}
      >
        <Grid item xs={7}>
          <Box className="left-grid_airTicketView">
            <Grid container style={{ padding: '10px' }}>
              <Grid item xs={12}>
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    fontSize: fonts.title,
                    color: themes.blackDefault,
                    fontWeight: 'bold',
                  }}
                >
                  {trans('Claim Details')}
                </Typography>
              </Grid>

              <CardContentTile
                tile_key={trans('Claim Type')}
                tile_value={claimViewData?.claim_type?.name}
              />

              <CardContentTile
                tile_key={trans('Claim Date')}
                tile_value={
                  <DateField
                    value={claimViewData?.date}
                    format={baseDateFormatting}
                  />
                }
              />
              <CardContentTile
                tile_key={trans('Amount')}
                tile_value={`${currency} ${getAmount(claimViewData?.amount)}`}
              />
              <CardContentTile
                tile_key={trans('Remarks')}
                tile_value={
                  claimViewData?.description ? claimViewData?.description : '--'
                }
              />
            </Grid>
            <Grid container style={{ padding: '10px' }}>
              <Grid item xs={12}>
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    fontSize: fonts.title,
                    color: themes.blackDefault,
                    fontWeight: 'bold',
                  }}
                >
                  {!claimViewData?.doc
                    ? trans('No Attachments Found')
                    : trans('Attachments')}
                </Typography>
              </Grid>
              <Box style={{ marginTop: '35px' }} />
              {claimViewData?.doc && (
                <DropAndSelect
                  src={claimViewData?.doc ? claimViewData?.doc : ''}
                  disabledDeleteBtn={true}
                  isAttachmentSigned={true}
                />
              )}
            </Grid>
          </Box>
        </Grid>

        <Grid item xs={5}>
          <Box className="right-grid_airTicketView">
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    fontSize: fonts.title,
                    color: themes.blackDefault,
                    fontWeight: 'bold',
                  }}
                >
                  {trans('Tracking Details')}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <VerticalBarController
                  instanceId={claimViewData?.workflow_instance?.id}
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <Box style={{ marginTop: '35px' }} />
      <ModalFooter
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal();
        }}
        isSubmitButton={false}
      />
    </CustomModal>
  );
};

export default ClaimViewModalPresenter;
